/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Group} from "./group";

/*
 * UI Class used to represent/show the available groups for the User
 */
export class GroupUI {
  mGroup: Group;
  mSelected = false;
}
